import React, { useState, useEffect } from "react";
import { FaArrowRight, FaDownload } from "react-icons/fa";
import "../css/Investorgrievance.css";

function Investorgrievance() {
  const [financialData, setFinancialData] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvestorgrievanceData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_Backend_URL}/InvestorGrievance/InvestorGrievanceDocument`
        );
        const result = await response.json();
        console.log(result);

        if (result.data) {
          setFinancialData(result.data); 
          setLoading(false); 
        } else {
          setError("Failed to fetch financial data.");
          setLoading(false); 
        }
      } catch (error) {
        setError("Error fetching financial data.");
        setLoading(false); 
      }
    };

    fetchInvestorgrievanceData();
  }, []);

  const handleViewClick = (fileUrl) => {
    setSelectedPdf(fileUrl);
  };

  const handleClosePreview = () => {
    setSelectedPdf(null);
  };

  return (
    <div className="grievance-container">
      <h1>Investor Grievance</h1>

      {loading && <p>Loading Investorgrievance...</p>}
      {error && <p style={{ color: "red" }}>Error: {error}</p>}

      {!loading && !error && financialData.length === 0 && (
        <p>No Details of Registrar found.</p>
      )}

      {!loading && !error && financialData.length > 0 && (
        <div>
          {financialData.map((grievance) => (
            <div className="grievance-row" key={grievance._id}>
              <div className="grievance-box">
                <h3>Name & Address</h3>
                <p>
                  <strong>Name:</strong> {grievance.name}
                </p>
                <p>
                  <strong>Address:</strong> {grievance.address}
                </p>
              </div>
              <div className="grievance-box">
                <h3>Contact Details</h3>
                <p>
                  <strong>Tel No:</strong> {grievance.number}
                </p>
                <p>
                  <strong>Email:</strong> {grievance.email}
                </p>
                <p>
                  <strong>Website:</strong>{" "}
                  <a
                    href="https://spinoff.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://spinoff.in/
                  </a>
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Investorgrievance;
